export default (coverImage) => ({
    imageSrc: coverImage,
    dropping: false,
    validType: true,
    dimensions: null,
    file: null,
    previewImage(event) {
        this.$dispatch('disable-save', false);
        const file = event.files[0];
        if (!file) return;
        const allowedTypes = ['image/png', 'image/jpg', 'image/jpeg'];

        // Only preview image if type is valid
        if (!allowedTypes.includes(file.type)) {
            this.validType = false;
            this.imageSrc = null;
            this.dimensions = null;
            return;
        } else {
            this.validType = true;

            const reader = new FileReader();            
            reader.addEventListener("load", (e) => {
                this.imageSrc = e.target.result;
                this.file = file;
                
            })
            reader.readAsDataURL(file);
            this.$refs.coverImageInput.files = event.files;
        }
    },
    validateImage(event) {
        if (!this.file) return;

        // Intrinsic image values
        const naturalWidth = event.target.naturalWidth
        const naturalHeight = event.target.naturalHeight

        // Checking valid values
        const validAspectRatio = naturalWidth / naturalHeight === 1; // True if it's a perfect square
        const validWidth = naturalWidth >= 1400 && naturalWidth <= 3000
        const validHeight = naturalHeight >= 1400 && naturalHeight <= 3000

        this.dimensions = {
            ratio: {
                valid: validAspectRatio,
                message: validAspectRatio ? "Image is a square" : "Image must be a perfect square",
            },
            size: {
                valid: validWidth && validHeight,
                message: `Size found: ${naturalWidth} x ${naturalHeight}px`
            }
        }

        if (!validAspectRatio || !validWidth || !validHeight) {
            // This event is used to disable the settings save button if either of the dimension rules are invalid
            this.$dispatch('disable-save', true);
        }
    },
    discardImage(event) {
        // This only discards the currently uploaded image, it doesn't delete an image that's already attached to an episode
        event.preventDefault();
        this.$dispatch('disable-save', false);
        coverImage ? this.imageSrc = coverImage : this.imageSrc = null;
        this.$refs.coverImageInput.value = "";
        this.dimensions = null;
        this.file = null;
        this.validType = true;
    },
});